import { useEffect, useState } from "react";

interface PreloaderProps {
  onComplete?: () => void;
  duration?: number;
  className?: string;
}

export function GlobalLoader({
  onComplete,
  duration = 3000,
  className = "",
}: PreloaderProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onComplete?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onComplete]);

  if (!isVisible) return null;

  return (
    <div
      className={`w-80 h-60 rounded-xl inset-0  flex items-center justify-center bg-white drop-shadow-2xl ${className}`}
    >
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <div className="relative h-12 w-12">
            <div className="absolute inset-0 rounded-full border-8 border-gray-200"></div>
            <div className="absolute inset-0 animate-spin rounded-full border-8 border-gray-600 border-t-transparent"></div>
          </div>
        </div>

        <h2 className="mb-3 text-xl font-semibold text-gray-800">Hold On</h2>

        <p className="max-w-sm text-sm text-gray-600 leading-relaxed">
          You are being redirected to another page,
          <br />
          it may take a few seconds.
        </p>
      </div>
    </div>
  );
}

export default GlobalLoader;
